import React from 'react';
import Label from 'ps-react/Label';

/** Optional label */
export default function ExampleOptional() {
  return <Label htmlFor="test" label="test" />
}
